import { HeroImage } from "../static-page-components/hero-image";
import desktopHero from "../../assets/home-owner/images/homeowner-hero-d.png";
import mobileHero from "../../assets/home-owner/images/homeowner-hero-m.png";
import { Box, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router";
import { Pages } from "../../utils";
import { HashLink } from "react-router-hash-link";

export const HomeownerUserHero = () => (
  <HeroImage image={desktopHero} mobileImage={mobileHero} className="homeowner-user-hero" sx={{
    minHeight: { xs: 897, md: 764 },
  }}>
    <Box
      sx={{
        minHeight: { xs: 220, md: 340 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: { xs: 'justify', md: "center" },
        py: { xs: 6, md: 12 },
        px: { xs: 4, md: 0 },
        maxWidth: {
          xs: "100%",
          md: "618px",
        },
        margin: "0 auto"
      }}
    >
      <Typography variant={"display1" as any}
        component="h1"
        sx={{ color: "#000", mb: "16px", textAlign: "center" }}>
        MEET YOUR <span className="text-pink">MATCH</span>
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: "550px", mb: { xs: 3.5, md: 4 } }}>
        We are the only platform that focuses on the relationship behind the home design project. Because when the designer truly gets you, your home will be better than you could have ever dreamed of.
      </Typography>
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        spacing="24px"
        sx={{
          maxWidth: { xs: "100%", md: "618px" },
          mx: "auto",
          width: { xs: "100%", md: "auto" },
        }}
      >
        <Button
          variant="contained"
          component={HashLink}
          to={Pages.LOGIN}
          sx={{ width: "100%" ,px: { xs: 1, md: "22px" }, py: { xs: "4px", md: "8px" }}}
        >
          Get Started
        </Button>
      </Stack>
    </Box>
  </HeroImage>
); 